// Sessão do cliente na mesa, guardada no próprio celular.
//
// A sessão É o `opened_at` da mesa: quando a conta fecha, o backend recusa o
// valor antigo e o celular se descarta sozinho. Guardar é só pra não pedir o
// CPF de novo a cada rodada, nunca pra dar acesso.
import { scopedGetItem, scopedSetItem, scopedRemoveItem } from "../../utils/tenantScope";

const CHAVE = "mesa_qr_sessao";

export function carregar(token) {
  try {
    const bruto = scopedGetItem(CHAVE);
    if (!bruto) return null;
    const dados = JSON.parse(bruto);
    if (!dados || dados.token !== token) return null;
    return dados;
  } catch {
    return null;
  }
}

// A sessão que o celular guarda de OUTRA mesa da loja (o cliente leu um QR
// diferente do da mesa em que está). Só serve identificada: sem cliente e
// chave não há mesa "dele" para voltar ou mudar.
export function carregarDeOutraMesa(token) {
  try {
    const dados = JSON.parse(scopedGetItem(CHAVE) || "null");
    if (!dados || !dados.token || dados.token === token) return null;
    return dados.cliente?.id && dados.chave && dados.opened_at ? dados : null;
  } catch {
    return null;
  }
}

// `chave` prova que este aparelho é o `cliente` na sessão; `eu` guarda se ele
// já foi liberado pelo anfitrião (pra voltar direto pra tela certa).
export function salvar(token, { opened_at, mesa, cliente, chave, eu }) {
  try {
    scopedSetItem(CHAVE, JSON.stringify({ token, opened_at, mesa, cliente, chave, eu }));
  } catch {
    /* navegador sem storage: a sessão vive só em memória */
  }
}

export function limpar() {
  try {
    scopedRemoveItem(CHAVE);
  } catch {
    /* nada a fazer */
  }
}
